import React, { useEffect, useState } from 'react'

// react meta tags
import { ReactTitle } from "react-meta-tags";

// react redux
import { connect } from "react-redux";

// themes
import Theme1 from './themes/ContactUsTheme1'

function ContactUs(props) {
    // props
    const {
        globalAppTheme,

        match
    } = props

    // states
    const [currentRoute, setCurrentRoute] = useState({})

    useEffect(() => {
        setCurrentRoute({
            routeUrl: "/contact-us/",
            routeName: "Contact Us"
        })
    }, [])

    return (
        <React.Fragment>
            {/* website title */}
            <ReactTitle title={"Contact Us | Ruhlistic Decor"} />

            {
                globalAppTheme === 'theme1' ? (
                    <Theme1 currentRoute={currentRoute} />
                ) : null
            }
        </React.Fragment>
    )
}

const getDataFromStore = (state) => {
    return {
        globalAppTheme: state.common.globalAppTheme,
    };
};

// const dispatchActionsToProps = (dispatch) => {
//     return {
//         func: param => dispatch(func(param)),
//     };
// };

export default connect(getDataFromStore, null)(ContactUs);